import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { take, switchMap } from 'rxjs/operators';
import { Observable, EMPTY } from 'rxjs';
import { PessoaJuridica } from 'app/model/pessoaJuridica';
import { ClienteApiService } from 'app/api/clienteApi.service';
import { NotificacoesApiService } from 'app/api/notificacoesApi.service';
import { AlertModalService } from 'app/shared/alert-modal.service';
import { LanguageDataTable } from 'app/shared/datatable/translate-datatable';
import { DataTableDirective } from 'angular-datatables';
import { SubSink } from 'subsink';

import * as moment from 'moment';

@Component({
  selector: 'app-webhook',
  templateUrl: './webhook.component.html',
  styleUrls: ['./webhook.component.css']
})

export class WebhookComponent implements OnInit, OnDestroy {

  clientes$: Observable<PessoaJuridica[]>;
  logResults = [];

  webhookForm: FormGroup;
  dataInicio: Date = null;
  dataFim: Date = null;
  public submitted: boolean = false;
  public loading: boolean = false;

  order = 'ocorridoEm';
  reverse = true;
  public paginaAtual = 1;
  public itensPorPagina = 25;

  @ViewChild(DataTableDirective, {static: false})
  datatableElement: DataTableDirective;
  filterCliente: string;
  pessoaJuridicaId: string;
  dtOptions: DataTables.Settings = {};
  orderCondition: number = 5;

  private subs = new SubSink();

  constructor(
    private notificacoesService: NotificacoesApiService,
    private clientesService: ClienteApiService,
    private alertService: AlertModalService,
    private formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.getClientes();
    this.startDataTable();
    this.webhookForm = this.formBuilder.group({
      desde: [null, Validators.required],
      ate: [null, Validators.required],
      pessoaJuridicaId: [''],
      apenasPendentes: [''],
      entidadeId: [''],
      urlContains: [''],
      ids: ['']
    });


    this.webhookForm.patchValue({ apenasPendentes: true });
    
  }

  get f() { return this.webhookForm.controls; }

  startDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 25,
      processing: true,
      responsive: true,
      order: [[this.orderCondition, "desc"]],
      language: LanguageDataTable.portugues_datatables
    };
}

  getClientes() {
    this.clientes$ = this.clientesService.v1ClienteGet();  
  }

  submitPesquisarLogs() {

    this.submitted = false;

    this.dataInicio = this.webhookForm.value.desde;
    this.dataFim = this.webhookForm.value.ate;

    this.loading = true;
    
    if (!this.dataInicio || !this.dataFim) {
      this.submitted = false;
      this.loading = false;
      return;
    }

    this.logResults = [];
    this.pesquisarLogs();

  }

  private formatarData(data: Date, inicio: boolean): string {
    const ano = data.getFullYear();
    const mes = data.getMonth();
    const dia = data.getDate();

    if (inicio) {
      return new Date(ano, mes, dia, 0, 0, 0).toISOString();
    } else {
      return new Date(ano, mes, dia, 23, 59, 59).toISOString();
    }
  }

  pesquisarLogs() {

    this.dataInicio = this.webhookForm.value.desde;
    this.dataFim = this.webhookForm.value.ate;

    let dataInicialFormatada = this.formatarData(this.dataInicio, true); // ajustando as horas para buscar desde a zero hora
    let dataFinalFormatada = this.formatarData(this.dataFim, false); // ajustando as horas para o limite de 23:59:59

    let newDataInicialFormatada = moment(dataInicialFormatada).toDate(); // Converter a string para Date novamente
    let newDataFinalFormatada = moment(dataFinalFormatada).toDate(); // Converter a string para Date novamente

    let inputApenasPendentes = this.webhookForm.value.apenasPendentes === true ? true : false;
    
    this.subs.sink = this.notificacoesService.v1NotificacoesGet(
      newDataInicialFormatada,
      newDataFinalFormatada,
      this.webhookForm.value.pessoaJuridicaId,
      inputApenasPendentes,
      this.webhookForm.value.entidadeId,
      this.webhookForm.value.urlContains,
      this.webhookForm.value.ids,
      ).subscribe( webhookNotifications => {

        this.submitted = true;

        if(webhookNotifications) {
          
          this.logResults.push(...webhookNotifications);

          this.loading = false;
          
        }
      });
  }

  reenviarNotificacao(desde, ate, pessoaJuridicaId, apenasPendentes, urlContains, entidadeId, id) {

    const data = {
      "desde":desde,
      "ate":ate,
      "pessoaJuridicaId":pessoaJuridicaId,
      "apenasPendentes":apenasPendentes,
      "urlContains":urlContains,
      "entidadeId":entidadeId,
      "ids":[id]
    }

    const result$ = this.alertService.showConfirm('Confirmação', 'Confirma o reenvio da notificação?');
    result$.asObservable()
      .pipe(
        take(1),
        switchMap(result => {
          if (result) { 
            return this.notificacoesService.v1NotificacoesPost(data);
          } else {
            return EMPTY;
          }
        })
      )
      .subscribe(
        success => {
          this.alertService.showAlertSuccess('Notificação reenviada com sucesso!');
        },
        error => {
          console.error("Erro:", error);
          if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
            this.alertService.showAlertDanger(error.Erros[0].Mensagem);
          } else {
            this.alertService.showAlertDanger('Erro ao reenviar a notificação. Tente novamente mais tarde.');
          }
        }
      );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}

